import {Component, OnInit, ViewChild} from '@angular/core';


@Component({
    templateUrl: './pgadmin.component.html',
    styleUrls: ['./pgadmin.component.scss']
})
export class PgadminComponent implements OnInit {
    fullPage: boolean;
    @ViewChild('iframe', {static: true}) iframe: any;

    constructor() {
    }

    ngOnInit(): void {
        this.fullPage = false;
        this.reloadPage();
    }

    toggleFullPage() {
        this.fullPage = !this.fullPage;
    }

    reloadPage() {
        this.iframe.nativeElement.src = '/pgadmin4/browser/';
    }
}
